import { useDialogContext } from '../../../contexts/DialogContext';
import { window } from '../../../globals';
import { useMutation } from '../../../ReactQuery';
import { put } from '../../../redux/api';

function convert() {
  return put<void, void>(`/api/organizations/subscription/poc-enterprise`, undefined);
}

/**
 * Custom hook to move organization to the POC Enterprise plan.
 */
export default function useConvertToPOCEnterprise() {
  const { onAlert } = useDialogContext();
  return useMutation({
    mutationFn: convert,
    onSuccess: () => {
      window.location.reload();
    },
    onError: () => {
      onAlert({
        title: 'Change Failed',
        body: 'Something went wrong while trying to move the organization to the POC plan.',
      });
    },
  });
}
